const mapStateToProps = (state) => {
    const {
        api:{
            savingDirectory,
            addingDirectory,
            deletingDirectory,
        }={},

        ui: {
            burgerMenuOpened
        } = {},

        service:{
            Api:{
                saveDirectory,
                addDirectory,
                deleteDirectory,
            }={},

        }={}
    } = state;
    return {
        savingDirectory,
        addingDirectory,
        deletingDirectory,
        saveDirectory,
        addDirectory,
        deleteDirectory,
        burgerMenuOpened
    }
}

export default mapStateToProps;